import React from 'react';
import { Switch, Route, Redirect, Link } from 'react-router-dom';

import { obtenirNumeroServeur } from '../../App_Code/Utils';
import Logo from '../../Img/Gmc_Blanc.svg';
import Logo2 from '../../Img/logo.png';
import OrishaLogo from '../../Img/ORISHA_LOGOTYPE_GROUPE_EXECUTE_POSITIF_RVB.png';

import PageConnexion from './PageConnexion';
import PageEmailOk from './PageEmailOk';

import PageInscription from './Inscription';
import PageInscriptionKo from './Inscription/PageInscriptionKo';
import PageDedefinirMdp from './Inscription/PageDefinirMdp';

import PageMdpOublie from './MdpOublie';
import PageRedefinir from './MdpOublie/PageRedefinir';
import PageMdpOublieKo from './MdpOublie/PageMdpOublieKo';

import PageNumeroMobile from './Ecourrier/PageNumeroMobile';
import PageCodeSMS from './Ecourrier/PageCodeSMS';
import PageEcourrierKo from './Ecourrier/PageEcourrierKo';
import PageEcourrierOk from './Ecourrier/PageEcourrierOk';
import PageSaisieMFA from './MFA';

const PagePleine = () => (
    <React.Fragment>
        <Link className="logogmc" to="/">
            <img
                src={Logo2}
                alt="Gérer ma copro"
                title="Gérer ma copro"
                aria-label={obtenirNumeroServeur()}
                aria-hidden="true"
            />
        </Link>
        <div className="card-body">
            <Switch>
                <Route exact path="/Connexion" component={PageConnexion} />
                <Route exact path="/Inscription" component={PageInscription} />
                <Route exact path="/Inscription/Valide" component={PageEmailOk} />
                <Route exact path="/Inscription/Invalide" component={PageInscriptionKo} />
                <Route exact path="/Inscription/DefinirMdp" component={PageDedefinirMdp} />
                <Route exact path="/MotdepasseOublie" component={PageMdpOublie} />
                <Route exact path="/MotdepasseOublie/Valide" component={PageEmailOk} />
                <Route exact path="/MotdepasseOublie/Invalide" component={PageMdpOublieKo} />
                <Route exact path="/MotdepasseOublie/RedefinirMdp" component={PageRedefinir} />
                <Route exact path="/Ecourrier/Valide" component={PageEmailOk} />
                <Route exact path="/Ecourrier/Invalide" component={PageEcourrierKo} />
                <Route exact path="/Ecourrier/ValideNG" component={PageEcourrierOk} />
                <Route exact path="/Ecourrier/SMSNumero" component={PageNumeroMobile} />
                <Route exact path="/Ecourrier/SMSCode" component={PageCodeSMS} />
                <Route exact path="/MFA" component={PageSaisieMFA} />
                <Redirect to="/Connexion" />
            </Switch>
        </div>
    </React.Fragment>
);

const PageIntegree = () => (
    <React.Fragment>
        <a target="_top" href={window.location.origin} title="Aller sur Gérer ma Copro" className="logogmc">
            <img className="card-img-top" src={Logo2} alt="Gérer ma copro" />
        </a>
        <div className="card-body">
            <PageConnexion />
        </div>
    </React.Fragment>
);

const AideInstall = () => (
    <React.Fragment>
        <p>Vous souhaitez l'installer en tant qu'application sur votre mobile ?</p>
        <a href="/docs/guide-installationGerermaCopro.pdf" target='blank' className="btn btn-block btn-success"> 
            Cliquez ici
        </a>
    </React.Fragment>
);

const PiedDePage = () => (
    <div className="footer">
        <div className="container">
            <div className="d-flex flex-wrap justify-content-center">
                <div className="p-2">
                    <a
                        id="Mentionslegales"
                        href="https://www.gerer-ma-copro.fr/mentions-legales/"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Mentions légales
                    </a>
                    <span> - </span>
                    <a
                        id="Conditions"
                        href="https://www.gerer-ma-copro.fr/conditions-generales-dutilisation/"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Conditions générales d&#39;utilisation
                    </a>
                    <span> - </span>
                    <span>
                        Copyright <i className="far fa-copyright" /> 1988-{new Date().getFullYear()}{' '} |
                        <span> - Tous droits réservés  </span>
                        <a id="KEL" href="https://www.kel.fr" target="_blank" rel="noreferrer noopener">
                        <img src={OrishaLogo} width="100" height="37" alt="Orisha" />
                        </a>
                    </span>
                </div>
            </div>
        </div>
    </div>
);

class Adherent extends React.Component {
    componentWillMount() {
        document.body.style.cssText = 'background-color: #e4f0f9;';
    }

    componentWillUnmount() {
        document.body.style.cssText = '';
    }

    render() {
        return (
            <div>
                <div className="d-flex justify-content-center align-items-center hauteur direction-col">
                    <div id="CardLogin" className="card">
                        {this.props.Iframe ? <PageIntegree /> : <PagePleine />}
                    </div>
                    <div id="CardLogin" className="card dessous">
                    <AideInstall />
                    </div>
                </div>
                <PiedDePage />
            </div>
        );
    }
}

export default Adherent;



// WEBPACK FOOTER //
// ./src/components/Adherent/index.js